export default __webpack_public_path__ + "static/media/Delete.02fd3e9e.svg";